export const BROWSER_HREF = {
  business_info: 'https://www.ftc.go.kr/bizCommPop.do?wrkr_no=2148891525',
  service_terms: 'https://cf.res.s.zigzag.kr/terms/user/service.html',
  privacy: 'https://cf.res.s.zigzag.kr/terms/user/privacy.html',
  escrow_license: 'https://www.nicepay.co.kr/apply/progress/escrow.do#none',
  payment_guarantee:
    'https://cf.res.s.zigzag.kr/%E1%84%89%E1%85%B5%E1%86%AB%E1%84%92%E1%85%A1%E1%86%AB%E1%84%8B%E1%85%B3%E1%86%AB%E1%84%92%E1%85%A2%E1%86%BC_%E1%84%8C%E1%85%B5%E1%84%80%E1%85%B3%E1%86%B8%E1%84%87%E1%85%A9%E1%84%8C%E1%85%B3%E1%86%BC%E1%84%89%E1%85%A5.pdf',
};
